import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Palette } from "../AppConfig";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

export const ContextMenu = withStyles({
    paper: {
        border: "1px solid " + Palette.Control.DarkBlueTrans,
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "left",
        }}
        anchorEl={props.menuAnchor}
        {...props}
    />
));

export const ContextMenuItem = withStyles((theme) => ({
    root: {
        font: "16px 'Univers45', sans-serif",
        padding: "12px 14px 12px 24px",
        "&:hover": {
            backgroundColor: Palette.Control.LightGrey,
            "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                // color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem);
